import React from 'react';

import {Group, Item} from '@pb/kit-component-group';
import {Icon, Icons} from '@pb/kit-component-icon';
import {Tooltip} from '@pb/kit-component-popups';

import {completeMarkFailed, completeMarkSuccess} from './complete-mark.module.styl';


type Props = {
    errors?: string[],
    message?: React.ReactNode,
    tooltip?: string[],
};

export const CompleteMarkComponent = ({errors, message, tooltip}: Props) => {
    if (errors?.length) {
        return (
            <Group className={completeMarkFailed} alignItems="center">
                <Tooltip
                    anchor={({anchorRef, getAnchorProps}) => (
                        <Icon type={Icons.ERROR} {...getAnchorProps()} ref={anchorRef}/>
                    )}
                    color="light"
                    placement="top-start">
                    <Group direction="v" gap="xs">
                        {message || errors.map((errorMessage, i) => (
                            <Item key={i}>{errorMessage.trim()}</Item>
                        ))}
                    </Group>
                </Tooltip>
                <span>{message || 'Failed'}</span>
            </Group>

        );
    }

    return (
        <Group alignItems="center">
            {tooltip?.length ? (
                <Tooltip
                    anchor={({anchorRef, getAnchorProps}) => (
                        <Icon type={Icons.INFO} {...getAnchorProps()} ref={anchorRef}/>
                    )}
                    color="light"
                    placement="top-start">
                    <Group direction="v" gap="xs">
                        {tooltip.map((tooltipMessage, i) =>
                            <Item key={i}>{tooltipMessage.trim()}</Item>)}
                    </Group>
                </Tooltip>
            ) : <Icon className={completeMarkSuccess} type={Icons.CHECK}/>}
            <span>{message || 'Completed'}</span>
        </Group>
    );
};
